import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2870c5ec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2870c5ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870c5ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2870c5ec')) {
      api.createRecord('2870c5ec', component.options)
    } else {
      api.reload('2870c5ec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2870c5ec&scoped=true", function () {
      api.rerender('2870c5ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/orderList/priceInquiry/index.vue"
export default component.exports